import $ from "cash-dom";
import Chart from 'chart.js/auto';

export const submissionsChartComponent = () => {
    const $submissionsChart = $('#submissions-chart');

    const data = {
        datasets: [{
            data: [
                $submissionsChart.attr('data-value-1'),
                $submissionsChart.attr('data-value-2'),
                $submissionsChart.attr('data-value-3'),
                $submissionsChart.attr('data-value-4'),
            ],
            backgroundColor: [
                '#38807C',
                '#304858',
                '#292663',
                '#326A76',
            ],
        }],
        labels: [
            $submissionsChart.attr('data-category-1'),
            $submissionsChart.attr('data-category-2'),
            $submissionsChart.attr('data-category-3'),
            $submissionsChart.attr('data-category-4'),
        ],
    };

    const config = {
        type: 'pie',
        data: data,
        options: {
            maintainAspectRatio: false,
            radius: '75%',
            plugins: {
                legend: {
                    position: 'right',
                    align: 'center',
                    labels: {
                        boxWidth: 30,
                        boxHeight: 30,
                        color: '#000000',
                        textAlign: 'left',
                        // usePointStyle: true,
                        padding: 10,
                        font: {
                            family: 'Source Sans Pro, Arial, sans-serif',
                            weight: 400,
                            size: 19,
                        },
                    }
                },
                tooltip: {
                    backgroundColor: '#304858f0',
                    boxPadding: 10,
                    padding: 6,
                    borderWidth: 1,
                    borderColor: '#304858',
                    bodyFont: {
                        family: 'Source Sans Pro, Arial, sans-serif',
                        weight: 400,
                        size: 19,
                    },
                },
            }
        },
    };


    const chart = new Chart(
        $submissionsChart.get(0),
        config
    );

    let updateTimeout = null;

    const onUpdate = () => {
        updateTimeout = null;
        chart.update();
    };

    const onResize = () => {
        chart.config.options.radius = window.innerWidth >= 812 ? '75%' : '100%';
        chart.config.options.plugins.legend.position = window.innerWidth >= 812 ? 'right' : 'top';
        chart.config.options.plugins.legend.align = window.innerWidth >= 812 ? 'center' : 'start';
        chart.config.options.plugins.legend.labels.font.size = window.innerWidth >= 400 ? 19 : 16;
        chart.config.options.plugins.tooltip.bodyFont.size = window.innerWidth >= 400 ? 19 : 16;

        if (!updateTimeout)
            updateTimeout = setTimeout(onUpdate, 500);
    };

    onResize();
    return {onResize};
};